<template>
  <li
    class="chat-message chat-message--without-padding chat-message-extension-image"
  >
    <img :src="data.extension.url" alt="" />
  </li>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  lastMessage: {
    type: Boolean,
    default: null,
  },
});
</script>
